import { RightsApi } from '@app/services/rights-service/rights-service';
import { enqueSnackAction } from '@app/store/snacks';
import { call, put } from 'redux-saga/effects';
import {
  createValueRightAction,
  fetchValueRightsAction,
  toggleModalAction,
} from '../actions';

export function* createValueRightsSaga(
  action: ReturnType<typeof createValueRightAction>
) {
  try {
    const dto = action.item;
    yield call(RightsApi.createValueRight, {
      ...dto,
    });
    yield put(
      enqueSnackAction({
        notification: {
          message: 'Product group rights successfully added.',
          options: {
            variant: 'success',
          },
          key: 'value-rights-add',
        },
      })
    );
    yield put(fetchValueRightsAction({}));
    yield put(toggleModalAction({ isOpen: false }));
  } catch (e) {
    yield put(toggleModalAction({ isOpen: true }));
    console.log('Failed to add value rights', e.message);
    if (
      e.response &&
      (e.response.status === 409 || e.response.status === 400)
    ) {
      yield put(
        enqueSnackAction({
          notification: {
            message: e.response.data.message,
            options: {
              variant: 'error',
            },
            key: 'value-rights-create',
          },
        })
      );
    }
    yield put(
      enqueSnackAction({
        notification: {
          message: 'Something wrong...',
          options: {
            variant: 'error',
          },
          key: 'value-rights-create',
        },
      })
    );
  }
}
